import axiosInstance from "./AxiosConfig";
import endpoints from "./endpoints";

export const dashboardService = {
  portfolioSummary: (userId) =>
    axiosInstance.get(`${endpoints.tokenEndPoints.portfolioSummary}/${userId}`),
};